<template lang="pug">
    .event-page
        .section(v-if="sections.length" v-for="(section, index) in filteredSections" :key="section.id" :class="section.key")
            Heading(v-if="section.key === 'heading'" :section="section")
            ImageSection(v-if="section.key === 'image'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
            EventList(v-if="section.key === 'events'" :section="section" :s="index")
</template>

<script>

import ContentPage from '@/views/ContentPage'
import EventList from '@/extensions/event-manager/components/EventList'

export default {
    name: 'EventPage',
    extends: ContentPage,
    components: {
        EventList
    },
    computed: {
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'image'
                    || section.key === 'post'
                    || section.key === 'slider'
                    || section.key === 'events'
            })
        },
    },
}
</script>
